import { render } from "./AddressValidator.vue?vue&type=template&id=d04d4ffa"
import script from "./AddressValidator.vue?vue&type=script&lang=js"
export * from "./AddressValidator.vue?vue&type=script&lang=js"

import "./AddressValidator.vue?vue&type=style&index=0&id=d04d4ffa&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__